import type { Language } from "./commonTypes";

export const AllCourses: Language[] = ["en", "es"];
